import {$swoole} from './axios.setup'

/**
 * 获取 JSSDK
 */
const fetchWeChatJSSDKConf = async (params) => {
  const url = '/v1/getJsSDK'
  const {data} = await $swoole.get(url, {
    params,
  })

  return data?.data || data
}

export {fetchWeChatJSSDKConf}
